import {observer} from 'mobx-react-lite'
import React, {useEffect} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Loader} from '@components/common/base/loader'
import {globals} from '@extensions/globals-base'
import {
  searchProgress,
  searchProgressUpdater
} from '@extensions/search-progress'

const TwContainer = tw.div`
  flex
  gap-8
  p-8
`

const TwText = tw.div`
  text-sm-regular
  text-primary
`

export const SearchProgress = observer(() => {
  const companyId = globals.getCompanyId()

  useEffect(() => {
    //
  }, [searchProgressUpdater.state.modified])

  const pr = searchProgress.getProgress(companyId)
  if (!pr) {
    return null
  }

  return (
    <TwContainer style={{letterSpacing: '-0.4px'}}>
      <Loader size="xsmall" />
      <TwText>{searchProgress.getPercent(companyId)}</TwText>
      <TwText>{Lang.msg.searchIndexing}</TwText>
    </TwContainer>
  )
})
